import React from 'react'

function Footer() {
  return (
       <footer className='w-full text-center bg-white shadow-inner fixed bottom-0 shadow-gray-200 text-purple-700 font-serif   py-5 '>
           
           <div> @copyRightreserve:- 2000 </div>
          
       </footer>
  )
}

export default Footer